import {
  logger,
  ScenarioColumns,
  TelemetryScenarioStatus,
  TelemetryScenarioStep,
  TelemetryScenarioTrackerData,
} from "@mwt/web-js-telemetry";
import { v4 as uuid } from "uuid";
import dayjs from "dayjs";
import { ApolloError } from "@apollo/client";

import { ScenarioName } from "./constants";

export const startLoggingAppSession = (error?: Error) => {
  const startTime = new Date();
  const id = uuid();

  sessionStorage.setItem("appLoad.startTime", startTime.toString());
  sessionStorage.setItem("appLoad.id", id);

  const telemetryEvent: TelemetryScenarioTrackerData = {
    id,
    [ScenarioColumns.ScenarioName]: ScenarioName.LogAppSession,
    [ScenarioColumns.ScenarioStep]: TelemetryScenarioStep.Start,
    [ScenarioColumns.ScenarioStatus]: TelemetryScenarioStatus.Init,
    startTime,
    elapsed: 1,
    stepDelta: 0,
  };

  if (error) {
    telemetryEvent.error = error;
    telemetryEvent[ScenarioColumns.ScenarioStatus] =
      TelemetryScenarioStatus.Failure;
  }

  logger.logScenarioTrackerEvent(telemetryEvent);
};

export const finishLoggingAppSession = (error?: ApolloError) => {
  const elapsed = 2;
  const startTime = dayjs(sessionStorage.getItem("appLoad.startTime"));
  const finishTime = dayjs();
  const id = sessionStorage.getItem("appLoad.id") ?? uuid();

  const duration = finishTime.diff(startTime);
  const scenarioStatus = error
    ? TelemetryScenarioStatus.Failure
    : TelemetryScenarioStatus.Success;
  const telemetryEvent: TelemetryScenarioTrackerData = {
    [ScenarioColumns.ScenarioName]: ScenarioName.LogAppSession,
    [ScenarioColumns.ScenarioStep]: TelemetryScenarioStep.Finish,
    lastUpdatedTime: finishTime.toDate(),
    finishTime: finishTime.toDate(),
    elapsed,
    id,
  };

  if (error) {
    telemetryEvent.error = new Error(error.message);
  }

  logger.logScenarioTrackerEvent({
    ...telemetryEvent,
    [ScenarioColumns.ScenarioStatus]: scenarioStatus,
    delta: duration,
    stepDelta: duration,
    elapsed: telemetryEvent.elapsed,
  });
};
